var exports = {
  "b": "Scroller.module__scrollerWrap___R3FDWU",
  "XG": "Scroller.module__scroller___R3FDWU",
  "xM": "Scroller.module__horizontal___R3FDWU",
  "RN": "Scroller.module__scrollbarReserve___R3FDWU",
  "Uv": "Scroller.module__scrollerChildren___R3FDWU",
  "cB": "Scroller.module__dragging___R3FDWU",
  "Hg": "Scroller.module__regular___R3FDWU",
};

module.exports = exports;
